;(function(){

    const button = document.querySelector('[data-projets-load-more]');
    const content = document.querySelector('.o-projets-posts__content');

    if (!button || !content || typeof crocus_js === 'undefined') return;

    let lastTouchTime = 0;

    const loadMore = async (event) => {
        if (event) {
            event.preventDefault();
        }

        if (button.classList.contains('is-loading')) return;

        button.classList.add('is-loading');
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;

        const body = new FormData();
        body.append('action', 'hds_load_more_projets');
        body.append('offset', button.dataset.offset || 0);
        body.append('per_page', button.dataset.perPage || 7);
        body.append('line_offset', button.dataset.lineOffset || 0);
        body.append('filter_taxo', button.dataset.filterTaxo || '');
        body.append('filter_term', button.dataset.filterTerm || '');
        body.append('search', button.dataset.search || '');
        body.append('lang', button.dataset.lang || '');

        try {
            const response = await fetch(crocus_js.ajaxurl, {
                method: 'POST',
                body,
            });

            if (!response.ok) {
                throw new Error(`Erreur AJAX ${response.status}`);
            }

            const result = await response.json();

            if (!result.success || !result.data) {
                throw new Error('Réponse AJAX invalide');
            }

            const wrapper = document.createElement('div');
            wrapper.innerHTML = result.data.html;

            const newContent = wrapper.querySelector('.o-projets-posts__content');
            if (newContent) {
                const fragment = document.createDocumentFragment();
                Array.from(newContent.children).forEach(item => fragment.appendChild(item));
                content.appendChild(fragment);

                if (typeof window.hdsInitLabels === 'function') {
                    window.hdsInitLabels(content);
                }

                if (typeof window.hdsInitCardProjet === 'function') {
                    window.hdsInitCardProjet(content);
                }
            }

            button.dataset.offset = result.data.next_offset;
            button.dataset.lineOffset = result.data.next_line_offset;

            if (!result.data.has_more) {
                const footer = button.closest('.o-projets-posts__footer');
                if (footer) footer.remove();
            }
        } catch (error) {
            console.error(error);
        } finally {
            button.classList.remove('is-loading');
            button.removeAttribute('aria-busy');
            button.disabled = false;
        }
    };

    button.addEventListener('touchend', (event) => {
        lastTouchTime = Date.now();
        loadMore(event);
    }, { passive: false });

    button.addEventListener('click', (event) => {
        if (Date.now() - lastTouchTime < 700) {
            event.preventDefault();
            return;
        }

        loadMore(event);
    });

}());
